export const workTemplateKeys = {
    all: ['workTemplate'] as const,
    list: (centerId: string) => [...workTemplateKeys.all, 'list', centerId] as const,
};
